module.exports = __webpack_public_path__ + "media/agenda-event.png";